import { inflateRaw } from 'pako';
export function unzip(input) {
    return inflateRaw(input.subarray(2));
}
//# sourceMappingURL=unzip-pako.js.map